import { Controller } from "@hotwired/stimulus"

// Toggles the mobile step bottom-sheet on the wizard stepper.
export default class extends Controller {
  static targets = ["sheet", "toggle"]

  toggle() {
    const open = this.sheetTarget.classList.toggle("hidden") === false
    this.sheetTarget.classList.toggle("flex", open)
    this.#setExpanded(open)
  }

  close() {
    this.sheetTarget.classList.add("hidden")
    this.sheetTarget.classList.remove("flex")
    this.#setExpanded(false)
  }

  stop(e) {
    e.stopPropagation()
  }

  #setExpanded(open) {
    if (this.hasToggleTarget) this.toggleTarget.setAttribute("aria-expanded", String(open))
  }
}
